'use strict';

angular.module('TurneroApp').component('coRecepcionTurnosAnunciar', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'turnosService',
        '$rootScope',
        '$scope',
        'utilsService',
        'signalrDotNetCoreService',
        'TurneroAppConstant',
        function (turnosService, $rootScope, $scope, utilsService, signalrServiceExterno, TurneroAppConstant) {
            var ctrl = this;

            //Limpiar variable, pone en false todas las banderas que son utilizadas para mostrar las diferentes pantallas, es decir las oculta a todas
            ctrl.limpiarVariables = function () {
                ctrl.mostrar = {
                    denegado: false,
                    turnosListado: false,
                    turnoAnunciado: false,
                    restriccionAnunciarse: false
                }
            }

            $scope.$on('limpiarRecepcion', function (event, bool) {
                ctrl.limpiarVariables();
            });

            //se ejecuta cuando cambia la persona seleccionada desde la pantalla de ingrese DNI
            $scope.$on('PersonaSeleccionada', function (event, persona) {
                ctrl.limpiarVariables();

                if (persona) {
                    //si la persona existe 
                    ctrl.ciudadano = persona;
                    ctrl.getAnunciar(persona);

                } else {
                    //si no existe
                    ctrl.mostrar.denegado = true
                }
            })

            ctrl.anunciar = function (Id_Turno) {
                //Anuncia el turno de la recepcion
                utilsService.swalTitle('Anunciando Turno', 'info');

                turnosService.Put_Turno_Anunciar({
                    'id_turno': Id_Turno, 'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                }).$promise.then(function (resultado) {
                    ctrl.limpiarVariables();
                    console.info("Desde el backend se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + Id_Turno + ".");
                    /*
                    signalrServiceExterno.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                        console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + Id_Turno + ".");
                        //actualizo ese turno en atención
                        hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, Id_Turno).then(function () {
                            console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + Id_Turno + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + Id_Turno + ": " + err.toString());
                        });
                    });
                    */
                    ctrl.mostrar.turnoAnunciado = true
                    swal.close();

                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            //en base a la pk de persona y el centro, busca los turnos que esten agendados para el dia de hoy
            ctrl.getAnunciar = function (persona) {
                var filtro = {
                    Id_Sexo: persona.Datos_RegistroCivil == null ? null : persona.Datos_RegistroCivil.Id_Sexo,
                    Nro_Documento:  persona.Datos_RegistroCivil == null ? persona.Datos_Cidi.N_Ciudadano_Cidi : persona.Datos_RegistroCivil.Nro_Documento,
                    Pai_Cod_Pais:  persona.Datos_RegistroCivil == null ? null : persona.Datos_RegistroCivil.Pai_Cod_Pais == undefined ? null : persona.Datos_RegistroCivil.Pai_Cod_Pais,
                    Id_Numero:  persona.Datos_RegistroCivil == null ? null : persona.Datos_RegistroCivil.Id_Numero,
                    Id_Centro_Atencion: ctrl.centroAtencionSeleccionado.id
                }

                utilsService.swalTitle('Procesando datos', 'info');
                turnosService.Get_Turnos_Para_Anunciar(filtro).$promise.then(function (resultado) {
                    //verifico que de los resultados obtenidos, los turnos se puedan anunciar, los que no se pueden anunciar se sacan de la lista
                    //primero verifica que el array tenga datos
                    if (resultado.Data.length) {
                        //si tiene un solo valor
                        if (resultado.Data.length == 1) {
                            // si el turno, tiene alguna restriccion de anuncio que todavia no se cumplio, db devuelva Permite_Anunciar == 0
                            //sino devuelve 1
                            ctrl.mostrar.restriccionAnunciarse = (resultado.Data[0].Permite_Anunciar == "0");
                            //Si no lo puedo anunciar lo saco de la lista
                            if (ctrl.mostrar.restriccionAnunciarse) { resultado.Data.splice(0, 1); }
                        } else {
                            //si es mas de un registro
                            for (var i = 0; i < resultado.Data.length; i++) {
                                //los que no se puedan anunciar los saco de la lista
                                if (resultado.Data[i].Permite_Anunciar == "0") {
                                    resultado.Data.splice(i, 1);
                                    i = i - 1;
                                }
                                //si luego de sacarlos no quedan registros. es porque no tiene turnos para anunciarse
                                if (resultado.Data.length == 0) {
                                    ctrl.mostrar.restriccionAnunciarse = true;
                                }
                            }
                        }

                    }
                    //Si tuviera un registro se lo selecciona y se lo anuncia
                    if (resultado.Data.length == 1) {
                        ctrl.Turno = resultado.Data[0];
                        ctrl.anunciar(ctrl.Turno.Id_Turno);
                    } else if (resultado.Data.length > 1) {
                        //si fuese mas de uno muestro el listado 
                        ctrl.TurnosLista = resultado.Data
                        ctrl.mostrar.turnosListado = true
                    } else {
                        //si no existieran turnos para anunciar y no es por restriccion de anuncio. es porque la persona no tiene turnos
                        if (!ctrl.mostrar.restriccionAnunciarse) {
                            ctrl.mostrar.denegado = true
                        }

                    }
                    swal.close();
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            //selecciona un turno del listado y lo anuncia
            ctrl.seleccionarTurno = function (turno) {
                ctrl.Turno = turno;
                ctrl.TurnosLista = null;
                ctrl.anunciar(ctrl.Turno.Id_Turno)
            }

            //redirecciona a la home de recepcion
            ctrl.goHome = function () {
                ctrl.ciudadano = null;
                ctrl.Turno = null;
                $rootScope.$broadcast('GoHome', true);
            }
            //vuelve a la pantalla anterior
            ctrl.goBack = function () {
                ctrl.ciudadano = null;
                ctrl.Turno = null;
                $rootScope.$broadcast('anunciarTurno', true);
            }
        }
    ],
    template: require('./recepcion_turnosAnunciar.html')
});


// WEBPACK FOOTER //
// ./app/components/recepcion/recepcion_turnosAnunciarComponent.js